export const appId = process.env['NX_PUBLIC_APP_ID'] || process.env['APP_ID'] || '';
